import type { GalleryElement } from '@/interfaces/components/galleryElement';
import type { HotelCatalogueImageType } from '@/interfaces/hotel-catalogue-types';
import { getAspectRatioInNumber } from 'src/utils/images';

export const catalogueIconsIntoGalleryElements = (
	catalogueIcons: HotelCatalogueImageType[],
	copyright: string = `© GIATA GmbH 1996 - ${new Date().getFullYear()}`
): GalleryElement[] => {
	return catalogueIcons.map((icon) => {
		return {
			alt: icon.Caption,
			content: icon.URL,
			preview: icon.Preview.URL,
			copyright: copyright ?? icon.Caption,
			type: 'image',
			aspectRatio: getAspectRatioInNumber(icon.Width, icon.Height),
		};
	});
};
